import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import CheckIcon from './images/check.svg';

const useStyles = makeStyles(theme => ({
  progressContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    margin: '40px 0 20px 0',
  },
  progressBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: 'auto',
    maxWidth: '100vw',
    marginBottom: 0,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  connector: {
    width: 64,
    height: 2,
    background: '#D0D0D0',
    margin: 0,
    zIndex: 2,
    transition: 'background 0.3s',
    [theme.breakpoints.down('sm')]: {
      width: 40,
    },
  },
  step: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 3,
  },
  stepCircle: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '600',
    fontSize: 14,
    color: '#FFFFFF',
    margin: 0,
    boxSizing: 'border-box',
    fontFamily: theme.typography.fontFamily,
  },
  stepCompleted: {
    '& $stepCircle': {
      backgroundColor: '#B8B9BB',
      color: 'white',
      boxShadow: 'none',
      border: 'none',
    },
  },
  stepCurrent: {
    '& $stepCircle': {
      backgroundColor: '#162C55',
      color: 'white',
      boxShadow: 'none',
      border: 'none',
    },
  },
  stepUpcoming: {
    '& $stepCircle': {
      backgroundColor: '#ECEDED',
      color: '#434345',
    },
  },
  checkmark: {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

/**
 * Custom ProgressIndicator component for Blue Shield of California
 *
 * Displays a horizontal stepper with completed, current, and future steps.
 */
const CustomProgressIndicator = ({ currentStep, totalSteps }) => {
  const classes = useStyles();

  // Calculate which steps are complete, current, or upcoming
  const steps = Array.from({ length: totalSteps }, (_, index) => {
    const stepNumber = index + 1;
    let status = 'upcoming';
    if (stepNumber < currentStep) status = 'completed';
    else if (stepNumber === currentStep) status = 'current';
    return { number: stepNumber, status };
  });

  return (
    <Box className={classes.progressContainer}>
      <Box className={classes.progressBar}>
        {steps.map((step, idx) => (
          <React.Fragment key={step.number}>
            <Box
              className={`${classes.step} ${
                classes[
                  `step${step.status.charAt(0).toUpperCase() +
                    step.status.slice(1)}`
                ]
              }`}
            >
              <Box className={classes.stepCircle}>
                {step.status === 'completed' ? (
                  <img
                    src={CheckIcon}
                    alt="Completed"
                    className={classes.checkmark}
                    width={24}
                    height={24}
                  />
                ) : (
                  step.number
                )}
              </Box>
            </Box>
            {idx < steps.length - 1 && (
              <Box
                className={classes.connector}
                style={{
                  background: idx < currentStep - 1 ? '#B8B9BB' : '#D0D0D0',
                }}
              />
            )}
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default CustomProgressIndicator;
